var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 134,
    height: 39,
    rx: 4.5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 134,
    height: 39,
    rx: 4.5,
    stroke: "#A6A6A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.137 21.7509C65.785 21.7509 63.868 23.5399 63.868 26.0039C63.868 28.4529 65.785 30.2569 68.137 30.2569C70.49 30.2569 72.407 28.4529 72.407 26.0039C72.406 23.5399 70.489 21.7509 68.137 21.7509ZM68.137 28.5829C66.848 28.5829 65.737 27.5199 65.737 26.0049C65.737 24.4739 66.849 23.4269 68.137 23.4269C69.426 23.4269 70.537 24.4739 70.537 26.0049C70.537 27.5189 69.426 28.5829 68.137 28.5829ZM58.823 21.7509C56.471 21.7509 54.554 23.5399 54.554 26.0039C54.554 28.4529 56.471 30.2569 58.823 30.2569C61.176 30.2569 63.093 28.4529 63.093 26.0039C63.093 23.5399 61.176 21.7509 58.823 21.7509ZM58.823 28.5829C57.534 28.5829 56.423 27.5199 56.423 26.0049C56.423 24.4739 57.535 23.4269 58.823 23.4269C60.112 23.4269 61.223 24.4739 61.223 26.0049C61.224 27.5189 60.112 28.5829 58.823 28.5829ZM47.745 23.0569V24.8609H52.063C51.934 25.8759 51.596 26.6169 51.08 27.1319C50.452 27.7599 49.469 28.4529 47.745 28.4529C45.087 28.4529 43.009 26.3099 43.009 23.6519C43.009 20.9939 45.087 18.8509 47.745 18.8509C49.179 18.8509 50.226 19.4149 50.999 20.1399L52.272 18.8669C51.192 17.8359 49.759 17.0469 47.745 17.0469C44.104 17.0469 41.043 20.0109 41.043 23.6519C41.043 27.2929 44.104 30.2569 47.745 30.2569C49.71 30.2569 51.193 29.6119 52.352 28.4039C53.544 27.2119 53.915 25.5359 53.915 24.1829C53.915 23.7649 53.883 23.3779 53.818 23.0559H47.745V23.0569ZM93.053 24.4579C92.699 23.5079 91.619 21.7509 89.412 21.7509C87.221 21.7509 85.4 23.4749 85.4 26.0039C85.4 28.3879 87.205 30.2569 89.621 30.2569C91.57 30.2569 92.698 29.0649 93.166 28.3719L91.716 27.4049C91.233 28.1139 90.572 28.5809 89.621 28.5809C88.671 28.5809 87.994 28.1459 87.559 27.2919L93.246 24.9399L93.053 24.4579ZM87.253 25.8759C87.205 24.2319 88.526 23.3949 89.477 23.3949C90.218 23.3949 90.846 23.7659 91.056 24.2969L87.253 25.8759ZM82.63 29.9999H84.498V17.4989H82.63V29.9999ZM79.568 22.7019H79.504C79.085 22.2019 78.279 21.7509 77.265 21.7509C75.138 21.7509 73.189 23.6199 73.189 26.0209C73.189 28.4049 75.138 30.2579 77.265 30.2579C78.28 30.2579 79.085 29.8069 79.504 29.2919H79.568V29.9039C79.568 31.5309 78.698 32.4009 77.297 32.4009C76.153 32.4009 75.444 31.5799 75.154 30.8869L73.527 31.5639C73.994 32.6909 75.234 34.0769 77.297 34.0769C79.488 34.0769 81.341 32.7879 81.341 29.6459V22.0099H79.569V22.7019H79.568ZM77.426 28.5829C76.137 28.5829 75.058 27.5029 75.058 26.0209C75.058 24.5219 76.137 23.4269 77.426 23.4269C78.698 23.4269 79.697 24.5219 79.697 26.0209C79.697 27.5029 78.698 28.5829 77.426 28.5829ZM101.807 17.4989H97.336V29.9999H99.201V25.2639H101.806C103.874 25.2639 105.908 23.7669 105.908 21.3819C105.908 18.9969 103.875 17.4989 101.807 17.4989ZM101.855 23.5239H99.201V19.2389H101.855C103.25 19.2389 104.042 20.3939 104.042 21.3819C104.042 22.3499 103.25 23.5239 101.855 23.5239ZM113.387 21.7289C112.036 21.7289 110.637 22.3239 110.058 23.6429L111.714 24.3339C112.068 23.6429 112.728 23.4169 113.419 23.4169C114.384 23.4169 115.365 23.9959 115.381 25.0249V25.1539C115.043 24.9609 114.319 24.6719 113.435 24.6719C111.65 24.6719 109.832 25.6529 109.832 27.4859C109.832 29.1589 111.296 30.2359 112.936 30.2359C114.19 30.2359 114.882 29.6729 115.316 29.0129H115.38V29.9779H117.182V25.1849C117.183 22.9669 115.525 21.7289 113.387 21.7289ZM113.161 28.5799C112.551 28.5799 111.698 28.2739 111.698 27.5179C111.698 26.5529 112.76 26.1829 113.677 26.1829C114.496 26.1829 114.883 26.3599 115.381 26.6009C115.236 27.7599 114.239 28.5799 113.161 28.5799ZM123.744 22.0019L121.605 27.4219H121.541L119.321 22.0019H117.311L120.64 29.5769L118.742 33.7909H120.688L125.819 22.0019H123.744ZM106.938 29.9999H108.803V17.4989H106.938V29.9999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4176 10.2432C47.4176 11.0812 47.1696 11.7482 46.6726 12.2462C46.1086 12.8382 45.3726 13.1342 44.4686 13.1342C43.6026 13.1342 42.8656 12.8342 42.2606 12.2342C41.6546 11.6332 41.3516 10.8892 41.3516 10.0012C41.3516 9.11219 41.6546 8.36819 42.2606 7.76819C42.8656 7.16719 43.6026 6.86719 44.4686 6.86719C44.8986 6.86719 45.3096 6.95119 45.6996 7.11819C46.0906 7.28619 46.4036 7.50919 46.6376 7.78819L46.1106 8.31619C45.7136 7.84119 45.1666 7.60419 44.4676 7.60419C43.8356 7.60419 43.2896 7.82619 42.8286 8.27019C42.3676 8.71419 42.1376 9.29119 42.1376 10.0002C42.1376 10.7092 42.3676 11.2862 42.8286 11.7302C43.2896 12.1742 43.8356 12.3962 44.4676 12.3962C45.1376 12.3962 45.6966 12.1732 46.1436 11.7262C46.4336 11.4352 46.6016 11.0302 46.6466 10.5112H44.4676V9.79019H47.3746C47.4046 9.94719 47.4176 10.0982 47.4176 10.2432Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0277 7.73724H49.2957V9.63924H51.7597V10.3602H49.2957V12.2622H52.0277V13.0002H48.5247V7.00024H52.0277V7.73724Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2785 13.0002H54.5075V7.73724H52.8315V7.00024H56.9545V7.73724H55.2785V13.0002Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9375 13.0002V7.00024H60.7085V13.0002H59.9375Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1277 13.0002H63.3567V7.73724H61.6807V7.00024H65.8037V7.73724H64.1277V13.0002Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6084 12.2252C73.0184 12.8312 72.2854 13.1342 71.4084 13.1342C70.5314 13.1342 69.7984 12.8312 69.2094 12.2252C68.6194 11.6192 68.3254 10.8772 68.3254 10.0002C68.3254 9.12323 68.6194 8.38123 69.2094 7.77523C69.7984 7.16923 70.5314 6.86523 71.4084 6.86523C72.2804 6.86523 73.0124 7.17023 73.6044 7.77923C74.1964 8.38823 74.4924 9.12823 74.4924 10.0002C74.4924 10.8772 74.1974 11.6192 73.6084 12.2252ZM69.7784 11.7222C70.2224 12.1722 70.7654 12.3962 71.4084 12.3962C72.0514 12.3962 72.5954 12.1712 73.0384 11.7222C73.4824 11.2722 73.7054 10.6982 73.7054 10.0002C73.7054 9.30223 73.4824 8.72823 73.0384 8.27823C72.5954 7.82823 72.0514 7.60423 71.4084 7.60423C70.7654 7.60423 70.2224 7.82923 69.7784 8.27823C69.3354 8.72823 69.1124 9.30223 69.1124 10.0002C69.1124 10.6982 69.3354 11.2722 69.7784 11.7222Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5745 13.0002V7.00024H76.5125L79.4285 11.6672H79.4615L79.4285 10.5112V7.00024H80.1995V13.0002H79.3945L76.3435 8.10625H76.3105L76.3435 9.26224V13.0002H75.5745Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4176 10.2432C47.4176 11.0812 47.1696 11.7482 46.6726 12.2462C46.1086 12.8382 45.3726 13.1342 44.4686 13.1342C43.6026 13.1342 42.8656 12.8342 42.2606 12.2342C41.6546 11.6332 41.3516 10.8892 41.3516 10.0012C41.3516 9.11219 41.6546 8.36819 42.2606 7.76819C42.8656 7.16719 43.6026 6.86719 44.4686 6.86719C44.8986 6.86719 45.3096 6.95119 45.6996 7.11819C46.0906 7.28619 46.4036 7.50919 46.6376 7.78819L46.1106 8.31619C45.7136 7.84119 45.1666 7.60419 44.4676 7.60419C43.8356 7.60419 43.2896 7.82619 42.8286 8.27019C42.3676 8.71419 42.1376 9.29119 42.1376 10.0002C42.1376 10.7092 42.3676 11.2862 42.8286 11.7302C43.2896 12.1742 43.8356 12.3962 44.4676 12.3962C45.1376 12.3962 45.6966 12.1732 46.1436 11.7262C46.4336 11.4352 46.6016 11.0302 46.6466 10.5112H44.4676V9.79019H47.3746C47.4046 9.94719 47.4176 10.0982 47.4176 10.2432Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0277 7.73724H49.2957V9.63924H51.7597V10.3602H49.2957V12.2622H52.0277V13.0002H48.5247V7.00024H52.0277V7.73724Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2785 13.0002H54.5075V7.73724H52.8315V7.00024H56.9545V7.73724H55.2785V13.0002Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9375 13.0002V7.00024H60.7085V13.0002H59.9375Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1277 13.0002H63.3567V7.73724H61.6807V7.00024H65.8037V7.73724H64.1277V13.0002Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6084 12.2252C73.0184 12.8312 72.2854 13.1342 71.4084 13.1342C70.5314 13.1342 69.7984 12.8312 69.2094 12.2252C68.6194 11.6192 68.3254 10.8772 68.3254 10.0002C68.3254 9.12323 68.6194 8.38123 69.2094 7.77523C69.7984 7.16923 70.5314 6.86523 71.4084 6.86523C72.2804 6.86523 73.0124 7.17023 73.6044 7.77923C74.1964 8.38823 74.4924 9.12823 74.4924 10.0002C74.4924 10.8772 74.1974 11.6192 73.6084 12.2252ZM69.7784 11.7222C70.2224 12.1722 70.7654 12.3962 71.4084 12.3962C72.0514 12.3962 72.5954 12.1712 73.0384 11.7222C73.4824 11.2722 73.7054 10.6982 73.7054 10.0002C73.7054 9.30223 73.4824 8.72823 73.0384 8.27823C72.5954 7.82823 72.0514 7.60423 71.4084 7.60423C70.7654 7.60423 70.2224 7.82923 69.7784 8.27823C69.3354 8.72823 69.1124 9.30223 69.1124 10.0002C69.1124 10.6982 69.3354 11.2722 69.7784 11.7222Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5745 13.0002V7.00024H76.5125L79.4285 11.6672H79.4615L79.4285 10.5112V7.00024H80.1995V13.0002H79.3945L76.3435 8.10625H76.3105L76.3435 9.26224V13.0002H75.5745Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_4604_3025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4357 7.53784C10.1447 7.84584 9.97266 8.32384 9.97266 8.94284V31.0588C9.97266 31.6788 10.1447 32.1558 10.4357 32.4638L10.5097 32.5358L22.8987 20.1468V20.0008V19.8548L10.5097 7.46484L10.4357 7.53784Z",
    fill: "url(#paint0_linear_4604_3025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0274 24.2776L22.8984 20.1466V20.0006V19.8546L27.0284 15.7246L27.1214 15.7776L32.0144 18.5576C33.4114 19.3516 33.4114 20.6506 32.0144 21.4456L27.1214 24.2256L27.0274 24.2776Z",
    fill: "url(#paint1_linear_4604_3025)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4604_3025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1215 24.224L22.8975 20L10.4355 32.463C10.8955 32.951 11.6565 33.011 12.5135 32.525L27.1215 24.224Z",
    fill: "url(#paint2_linear_4604_3025)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.1215 15.7767L12.5135 7.4767C11.6565 6.9897 10.8955 7.0507 10.4355 7.5387L22.8985 20.0017L27.1215 15.7767Z",
    fill: "url(#paint3_linear_4604_3025)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_4604_3025",
    x: 9.97266,
    y: 7.14062,
    width: 23.0898,
    height: 25.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4604_3025"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4604_3025",
    result: "effect2_innerShadow_4604_3025"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4604_3025",
    x: 10.4355,
    y: 20,
    width: 16.6855,
    height: 12.8613,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4604_3025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4604_3025",
    x1: 21.8005,
    y1: 8.70884,
    x2: 5.01846,
    y2: 25.4908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4604_3025",
    x1: 33.8329,
    y1: 20.0006,
    x2: 9.63704,
    y2: 20.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4604_3025",
    x1: 24.8276,
    y1: 22.2939,
    x2: 2.06915,
    y2: 45.0524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4604_3025",
    x1: 7.29695,
    y1: 0.176501,
    x2: 17.4592,
    y2: 10.3388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleBlack);
export default __webpack_public_path__ + "static/media/google-black.c8de98c5e66dbc1db8c1a706ae1a9410.svg";
export { ForwardRef as ReactComponent };